import React, { Component } from 'react';
import 'bootstrap/dist/css/bootstrap.css';
import '../Admin/Admin.css';
import CollapseCard from '../CollapseCard/CollapseCard';
import Widgets from './Widgets';

class WidgetContainer extends Component {
    constructor(props) {
        super(props);
        this.blankWidget = {
            widgetId: 0,
            name: '',
            description: '',
            configuration: '',
            types: '',
            module: '',
            order: 0,
            active: true,
            deleted: false,
            clients: []
        }
        this.state = {
            widgets: [],
            widgetId: 0,
            editWidget: { ...this.blankWidget },
            newWidget: { ...this.blankWidget },
            isLoaded: false,
        };
    }

    componentDidMount() {
        this.props.log('WidgetContainer.js/componentDidMount');
        this.getWidgets();
    }

    componentWillUnmount() {
        this.props.log('Client.js/componentWillUnmount');
        this.isUnmounted = true;
    }

    getWidgets = () => {
        this.props.log('WidgetContainer.js/getWidgets');
        fetch('/api/widgets/', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken
            }
        })
            .then(results => results.json())
            .then(results => {
                if (this.isUnmounted) return;
                if (results.success) {
                    this.setState({
                        widgets: results.data,
                        isLoaded: true
                    });
                } else {
                    this.props.addToast('Unable to load widgets.', 5, 'danger');
                }
            })
            .catch(() => {
                this.props.addToast('An error has occurred.', 5, 'danger');
            })
    }

    onEditWidget = (widgetId) => {
        this.props.log('WidgetContainer.js/onEditWidget (widgetId)', widgetId);
        const widget = [...this.state.widgets].filter(item => item.widgetId === widgetId)[0];
        this.setState(() => {
            return {
                editWidget: {
                    widgetId: widget.widgetId,
                    name: widget.name,
                    description: widget.description,
                    configuration: widget.configuration,
                    types: widget.types,
                    module: widget.module,
                    order: widget.order,
                    active: widget.active,
                    deleted: widget.deleted,
                    clients: widget.clients != null ? widget.clients : []
                }
            }
        })
    }

    onDeleteWidget = (widgetId) => {
        this.props.log('WidgetContainer.js/onDeleteWidget (widgetId)', widgetId);
        fetch('/api/widgets/' + widgetId, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken
            }
        })
            .then(results => results.json())
            .then(results => {
                if (results.success) {
                    this.getWidgets();
                    this.props.addToast('Widget deleted successfully.', 5, 'success')
                } else {
                    this.props.addToast('Unable to delete widget.', 5, 'danger')
                }
            })
            .catch(() => {
                this.props.addToast('An error has occurred.', 5, 'danger');
            })
    }

    onChangeWidget = (e, type) => {
        this.props.log('WidgetContainer.js/onChangeWidget (e, type)', e, type);
        e.persist();
        let thisWidget = (type === 'edit') ? this.state.editWidget : this.state.newWidget;
        switch (e.target.name) {
            case "active":
                thisWidget[e.target.name] = !thisWidget[e.target.name];
                break;
            case "clients":
                const clientId = parseInt(String(e.target.id).split('_')[1]);
                const index = thisWidget.clients.findIndex(item => item === clientId);
                if (index > -1) thisWidget.clients.splice(index, 1);
                if (e.target.checked) thisWidget.clients.push(clientId);
                break;
            default:
                thisWidget[e.target.name] = e.target.value;
        }
        this.setState((prevState) => {
            return (type === 'edit') ? { editWidget: thisWidget } : { newWidget: thisWidget };
        });
    }

    handleCancelWidget = () => {
        this.props.log('WidgetContainer.js/handleCancelWidget');
        this.setState({
            editWidget: { ...this.blankWidget },
        })
    }

    handleAddWidget = (e) => {
        this.props.log('WidgetContainer.js/handleAddWidget');
        let newOrder = Math.max(...this.state.widgets.map(i => i['order']), 0) + 10;
        fetch('/api/widgets/', {
            method: 'POST',
            body: JSON.stringify({
                name: this.state.newWidget.name,
                description: this.state.newWidget.description,
                configuration: this.state.newWidget.configuration,
                types: this.state.newWidget.types,
                module: this.state.newWidget.module,
                order: newOrder,
                active: this.state.newWidget.active,
            }),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken
            }
        })
            .then(results => results.json())
            .then(results => {
                if (parseInt(results.data) > 0) {
                    this.setState({
                        newWidget: { ...this.blankWidget },
                    }, () => this.getWidgets());
                    this.props.addToast('Widget added successfully.', 5, 'success')
                } else {
                    this.props.addToast('Unable to add widget.', 5, 'danger')
                }
            })
            .catch(() => {
                this.props.addToast('An error has occurred.', 5, 'danger');
            })
    }

    handleEditWidget = () => {
        this.props.log('WidgetContainer.js/handleEditWidget');
        fetch('/api/widgets/' + this.state.editWidget.widgetId, {
            method: 'PUT',
            body: JSON.stringify({
                name: this.state.editWidget.name,
                description: this.state.editWidget.description,
                configuration: this.state.editWidget.configuration,
                types: this.state.editWidget.types,
                module: this.state.editWidget.module,
                order: this.state.editWidget.order,
                active: this.state.editWidget.active,
                deleted: this.state.editWidget.deleted,
                clients: this.state.editWidget.clients
            }),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken
            }
        })
            .then(results => results.json())
            .then(results => {
                if (results.success) {
                    this.setState({
                        editWidget: { ...this.blankWidget },
                    }, () => this.getWidgets());
                    this.props.addToast('Widget updated successfully.', 5, 'success')
                } else {
                    this.props.addToast('Unable to update widget.', 5, 'danger')
                }
            })
            .catch(() => {
                this.props.addToast('An error has occurred.', 5, 'danger');
            })
    }

    setDragTarget = (widgetId) => {
        this.props.log('WidgetContainer.js/setDragTarget (widgetId)', widgetId);
        this.setState({
            widgetId: widgetId
        })
    }

    reorder = () => {
        this.props.log('WidgetContainer.js/reorder()');
        let dbWidgets = [];
        let data = [...this.state.widgets];
        data = data.map((widget, widgetIndex) => {
            if (dbWidgets.findIndex(item => item.widgetId === widget.widgetId) === -1) dbWidgets.push({ widgetId: widget.widgetId, order: (widgetIndex + 1) * 10 })
            return { ...widget, order: (widgetIndex + 1) * 10 }
        })
        this.setState({ widgets: data }, () => {
            fetch('/api/widgets-order/', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + this.props.clientToken
                },
                body: JSON.stringify(
                    { widgets: dbWidgets }
                )
            }, () => this.getWidgets())
        });
    }

    render() {
        this.props.info('WidgetContainer.js/render');
        const dragProps = {
            onDragEnd: (fromIndex, toIndex) => {
                const data = [...this.state.widgets];
                const item = data.splice(fromIndex, 1)[0];
                data.splice(toIndex, 0, item);
                this.setState({ widgets: data }, () => this.reorder());
            },
            nodeSelector: 'div.widgetRow',
            handleSelector: 'span.dragIcon'
        };

        return (
            (this.state.isLoaded) ?
                <>
                    <CollapseCard title="Widget Management" open={true}>
                        <Widgets
                            {...this.props}
                            widgets={this.state.widgets}
                            newWidget={this.state.newWidget}
                            editWidget={this.state.editWidget}
                            dragProps={dragProps}
                            onChange={this.onChangeWidget}
                            onEdit={this.onEditWidget}
                            onDelete={this.onDeleteWidget}
                            handleAdd={this.handleAddWidget}
                            handleEdit={this.handleEditWidget}
                            handleCancel={this.handleCancelWidget}
                            setDragTarget={this.setDragTarget}
                            log={this.props.log}
                            info={this.props.info}
                        />
                    </CollapseCard>
                </>
                :
                <h3>Loading...</h3>
        );

    }
}

export default WidgetContainer;
